import { z } from 'zod';
import { flowConditionalConfigSchema } from '../../conditional/conditionalConfig.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowConditionalBlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Conditional),
    config: flowConditionalConfigSchema,
});
//# sourceMappingURL=config.js.map